<nb-layout>
  <nb-layout-column>
    <div *ngIf="responsiveMode === 'lg'"
         class="d-flex flex-column align-items-center justify-content-center position-relative error-500">
      <div class="m-auto py-5 text-center">
        <img src="assets/images/errors/sso-error.png" alt="" style="width: 80%;">
        <div class="d-flex flex-column align-items-center justify-content-between text-position ">
          <p class="info mb-3 mt-1 type-1" style="font-size: 18px;">
            کاربری با این کد ملی در سامانه موجود نیست.
          </p>
          <p class="description" style="font-size: 13px;"> لطفاً جهت ادامه با راهبر سیستم تماس بگیرید.</p>
        </div>
      </div>
    </div>
    <div *ngIf="responsiveMode === 'md'" class="m-auto">
      <img src="assets/images/errors/sso-error.png" alt="">
      <div class="d-flex flex-column align-items-center justify-content-between">
        <p class="info mb-3 mt-1 type-1" style="font-size: 18px;">
          کاربری با این کد ملی در سامانه موجود نیست.
        </p>
        <p class="description" style="font-size: 13px;"> لطفاً جهت ادامه با راهبر سیستم تماس بگیرید.</p>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>

